import type { IconSvgObject } from './types';

const CircleArrowLeftRightIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.5 9.00003L15.5 9.00003M15.5 9.00003L13.5 7M15.5 9.00003L13.5 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.5 17L8.5 15M8.5 15L10.5 13M8.5 15L15.5 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CircleArrowLeftRightIcon;
